<template>
	<router-link tag="a" :to="`/producto/${item.slug}`" class="item" :class="{ 'item-horizontal': display == 'horizontal' }">
		<div class="image" :style="'background-image:url(' + item.image.url + ')'"></div>

		<div class="data">
			<!-- <div class="badge badge-primary" v-if="item.featured">
				OPORTUNIDAD
			</div> -->
			<div class="title">{{ item.name }}</div>
			<div class="price" v-if="item.salable">
				<span class="currency mr-1">U$S</span>
				<span class="amount">{{ item.price }}</span>
				<small class="ml-1">IVA INC</small>
			</div>
			<div class="mb-2" v-if="item.featured" v-html="item.featuredDetail"></div>
			<button class="btn btn-block btn-primary ">
				Más info
			</button>
		</div>
	</router-link>
</template>
<script>
export default {
	props: ['item', 'display'],
}
</script>
<style scoped>
.item {
	display: flex;
	flex-direction: column;
	position: relative;
	margin: 8px;
	padding: 14px 8px;
	text-align: center;
	color: #000;
	transition: all 0.4s ease-in-out;
	height: 100%;
}
.item:hover {
	background-color: #f8f8f8;
}
.item:hover .btn {
	background-color: #000000;
	color: #ffffff;
}

.item .title {
	font-weight: 600;
	font-size: 16px;
	line-height: 16px;
	z-index: 10;
}
.item .image {
	width: 100%;
	max-width: 320px;
	padding-bottom: 60%;
	margin: auto;
	background-size: contain;
	background-position: center center;
	background-repeat: no-repeat;
}
.item .data {
	display: flex;
    flex-direction: column;
    position: relative;
    flex-grow: 1;
    text-align: center;
    align-items: center;
    justify-content: space-between;
}

.item .price {
	font-size: 14px;
	line-height: 20px;
}
.item .price .currency {
	font-size: 14px;
	font-weight: 500;
}
.item .price .amount {
	font-size: 16px;
	font-weight: 600;
}

.badge-primary {
	width: 90px;
	background-color: var(--primary-color);
	border-radius: 20px;
	font-size: 10px;
	font-weight: 500;
	padding: 6px;
	position: absolute;
	top: -20px;
	left: calc(50% - 45px);
}

.item.item-horizontal {
	flex-direction: row;
	align-items: center;
}
.item.item-horizontal .image {
	padding-bottom: 30%;
}
.item.item-horizontal .data {
	text-align: left;
}
.item.item-horizontal .data .btn {
	margin: inherit;
}
</style>
